import React from 'react';
import { Field, SelectInput } from '../lib/FormControls';
import { RATE_CLASS_OPTIONS } from '../lib/fieldDefs';

export default function Step6Illustration({ form, setField }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Illustration / Quote</h2>
      <div className="max-w-sm">
        <Field label="Rate Class" required>
          <SelectInput
            value={form.rate_class}
            onChange={(e) => setField('rate_class', e.target.value)}
            options={RATE_CLASS_OPTIONS}
          />
        </Field>
      </div>
    </div>
  );
}
